<template>
  <nav class="pagination">
    <ul class="pagination__list">
      <li class="pagination__list-item">
        <a
          v-if="pagination.page > 1"
          href="#"
          class="pagination__link"
          @click.prevent="handlePaginationClick(true, false)"
        >
          <img
            src="/img/icon/caret-left-black.svg"
            alt="Previous"
            class="pagination__icon"
            width="9"
            height="16"
          >
        </a>
        <button
          v-else
          disabled
          class="pagination__button pagination__button--disabled"
        >
          <img
            src="/img/icon/caret-left-black.svg"
            alt="Previous"
            class="pagination__icon"
            width="9"
            height="16"
          >
        </button>
      </li>
      <li
        v-for="(page, index) in pagesToShow"
        :key="index"
        class="pagination__list-item"
      >
        <span
          v-if="typeof page === 'string'"
          class="pagination__separator"
        >
          {{ page }}
        </span>
        <a
          v-else-if="page !== pagination.page && typeof page !== 'string'"
          href="#top"
          class="pagination__link"
          @click.prevent="handlePaginationClick(false, false, page)"
        >
          {{ page }}
        </a>
        <button
          v-else
          disabled
          class="pagination__button pagination__button--current pagination__button--disabled"
        >
          {{ page }}
        </button>
      </li>
      <li class="pagination__list-item">
        <a
          v-if="pagination.page < pagination.pageCount"
          href="#top"
          class="pagination__link"
          @click.prevent="handlePaginationClick(false, true)"
        >
          <img
            src="/img/icon/pagination-next-black.svg"
            alt="Next"
            class="pagination__icon"
            width="18"
            height="auto"
          >
        </a>
        <button
          v-else
          disabled
          class="pagination__button pagination__button--disabled"
        >
          <img
            src="/img/icon/pagination-next-black.svg"
            alt="Next"
            class="pagination__icon"
            width="18"
            height="auto"
          >
        </button>
      </li>
    </ul>
    <p class="pagination__paragraph">
      {{ pagination.from ? pagination.from : 0 }} -
      {{ pagination.to ? pagination.to : 0 }} of
      {{ pagination.resultCount }} businesses
    </p>
  </nav>
</template>

<script>
export default {
  props: {
    pagination: { required: true, type: Object },
  },
  data() {
    return {
      pagesToShow: [],
    };
  },
  // Listen for changes from parent
  watch: {
    $props: {
      handler() {
        this.setPagesToShow();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setPagesToShow() {
      let pagesToShow = [];
      let pageCount = this.pagination.pageCount;
      if (pageCount <= 5) {
        pagesToShow = Array.from({ length: pageCount }, (v, i) => i + 1);
      } else {
        let currentPage = this.pagination.page;
        let dots = '...';
        if (currentPage < 5) {
          pagesToShow = Array.from({ length: 5 }, (v, i) => i + 1);
          pagesToShow.push(dots);
          pagesToShow.push(pageCount);
        } else if (currentPage >= 5 && pageCount - currentPage >= 4) {
          pagesToShow.push(1);
          pagesToShow.push(dots);
          pagesToShow.push(currentPage - 1);
          pagesToShow.push(currentPage);
          pagesToShow.push(currentPage + 1);
          pagesToShow.push(dots);
          pagesToShow.push(pageCount);
        } else {
          let pageCountToArray = Array.from(
            { length: pageCount },
            (v, i) => i + 1,
          );
          pagesToShow.push(1);
          pagesToShow.push(dots);
          pagesToShow.push(
            ...pageCountToArray.slice(pageCountToArray.length - 5),
          );
        }
      }
      this.pagesToShow = pagesToShow;
    },
    handlePaginationClick(prev, next, page = null) {
      this.$emit('updatePagination', prev, next, page);
    },
  },
};
</script>
